module.exports = __webpack_public_path__ + "1e44730c5122fcfff2045cfd0ac42f50.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/nav_introduction.svg
 ** module id = 261
 ** module chunks = 0
 **/